import React, { useEffect, useState } from 'react';
import '../../styles/globals.css'
import { Box, Card, Typography, Grid, Grow, Link, Fade, LinearProgress } from '@mui/material'
import karmaStyles from '../../styles/KarmaPool.module.css'
import DashboardMenuHeaderComponent from './header/DashboardMenuHeaderComponent';
import DashboardLogoutFooterComponent from './footer/DashboardLogoutFooterComponent';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';
import CycleTimer from './cycles/CycleTimer';


function DashboardCycle() {

    const karmaContext = useKarmaPoolContext();


    function GetUserGbpToGoodCausesTo2DP() {
        if (karmaContext.local.user.gbpGivenByUserAllTime == null) {
            return "0.00";
        }

        return karmaContext.local.user.gbpGivenByUserAllTime.toFixed(2);
    }

    function GetUserGbpToThoseInNeed() {
        if (karmaContext.local.user.gbpToThoseInNeed == null) {
            return "0.00";
        }

        return karmaContext.local.user.gbpToThoseInNeed.toFixed(2);
    }

    return (
        <>
            <Box className={karmaStyles.homepageBox2}>
                <DashboardMenuHeaderComponent
                    causesEnabled={true} />
            </Box>

            <Box className={karmaStyles.homepageBox3}>
                <Grid container spacing={1} sx={{ marginBottom: "1.0rem", marginTop: "-1.325rem" }}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grow in={true} style={{ animationDuration: '0.125s' }}>
                            <Box sx={{ paddingRight: "1.0rem", paddingLeft: "1.0rem", display: "flex", justifyContent: "center", marginTop: "0.875rem" }}>
                                <Card sx={{
                                    width: "85%",
                                    maxWidth: "21.25em",
                                    minWidth: "19.5em",
                                    backgroundColor: "rgba(221, 221, 221, 0.075)",
                                    borderRadius: "0.25rem",
                                    borderColor: "rgba(221, 221, 221, 0.25)",
                                    border: "1px solid rgba(221, 221, 221, 0.35)",
                                    marginBottom: "0.5rem"

                                }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ marginTop: "0.75rem", marginBottom: "1.0rem", color: "whitesmoke" }}>
                                        <CycleTimer />
                                    </Typography>
                                    {true ? <></> :
                                        <LinearProgress variant="determinate" value={72} sx={{
                                            height: "0.5rem",
                                            '& .MuiLinearProgress-bar': {
                                                backgroundColor: 'rgba(255, 255, 255, 0.675)', // Set the pink color for the filled portion
                                            },
                                            backgroundColor: "rgba(221, 221, 221, 0.25)",
                                            borderRadius: "0.25rem"
                                        }}
                                        />
                                    }
                                </Card>
                            </Box>
                        </Grow>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ marginTop: "-0.25rem", color: "whitesmoke" }}>
                        <Box sx={{}}>

                            <Fade in={true} style={{ animationDuration: '0.125s' }}>
                                <Typography variant="body2" color="text.secondary" sx={{ marginTop: "0.375em", color: "whitesmoke" }}>
                                    <Link href={"/karma/dashboard/causes"}>
                                        continue
                                    </Link>
                                </Typography>
                            </Fade>
                        </Box>
                    </Grid>

                </Grid>
            </Box>
        </>
    );
}

export default DashboardCycle;


